// 5 distinct greyscale line colors (spec: "min 5 distinct greys before cycling")
export const LINE_COLORS = [
  'rgba(148, 163, 184, 0.9)', // slate-400
  'rgba(100, 116, 139, 0.9)', // slate-500
  'rgba(71, 85, 105, 0.9)',   // slate-600
  'rgba(203, 213, 225, 0.8)', // slate-300
  'rgba(51, 65, 85, 0.9)',    // slate-700
];

// Traffic-light signal colors (used ONLY for threshold breaches/violations)
export const SIGNAL = {
  critical: '#DC2626',
  warning: '#D97706',
  healthy: '#16A34A',
};

// Sigma band colors (greyscale, not colored)
export const SIGMA_BANDS = {
  one: 'rgba(148, 163, 184, 0.08)',
  two: 'rgba(148, 163, 184, 0.05)',
  three: 'rgba(148, 163, 184, 0.03)',
};

export function setupCanvas(canvas: HTMLCanvasElement): CanvasRenderingContext2D | null {
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;
  const dpr = window.devicePixelRatio || 1;
  const rect = canvas.getBoundingClientRect();
  canvas.width = rect.width * dpr;
  canvas.height = rect.height * dpr;
  ctx.scale(dpr, dpr);
  return ctx;
}

export function drawGridLines(
  ctx: CanvasRenderingContext2D, width: number, height: number,
  padding: { top: number; right: number; bottom: number; left: number },
  yMin: number, yMax: number, lineCount = 5,
) {
  ctx.strokeStyle = 'rgba(148, 163, 184, 0.1)';
  ctx.lineWidth = 0.5;
  ctx.font = '10px SF Mono, monospace';
  ctx.fillStyle = 'rgba(148, 163, 184, 0.5)';
  ctx.textAlign = 'right';
  const plotH = height - padding.top - padding.bottom;
  for (let i = 0; i <= lineCount; i++) {
    const y = padding.top + (plotH * i) / lineCount;
    const value = yMax - ((yMax - yMin) * i) / lineCount;
    ctx.beginPath();
    ctx.moveTo(padding.left, y);
    ctx.lineTo(width - padding.right, y);
    ctx.stroke();
    ctx.fillText(formatValue(value), padding.left - 4, y + 3);
  }
}

export function formatValue(v: number): string {
  if (v >= 1000) return `${(v / 1000).toFixed(1)}k`;
  if (v >= 1) return v.toFixed(0);
  return v.toFixed(2);
}

export function formatDuration(ms: number): string {
  if (ms < 1000) return `${ms}ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  return `${(ms / 60000).toFixed(1)}m`;
}

export function formatTime(ts: string): string {
  return new Date(ts).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}
